export default {
  name: 'processing',
  path: 'processing-time',
  component: () => import(/* webpackChunkName: "processing" */ '@/views/report/processing/index'),
};
